import { SmsAccountCacheService } from "./cache";
import type { tSmsAccount } from "@/types";

export const SmsAccountMutationHandler = {
  accountUpdated({ account }: { account: tSmsAccount }) {
    SmsAccountCacheService.replaceAccount(account);
  },
};
